import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import type React from 'react';

interface ComponentProps {
  inputAdornmentRef?: React.MutableRefObject<HTMLDivElement | null>;
}

function InputAdormentLoading({ inputAdornmentRef }: ComponentProps) {
  return (
    <InputAdornment position="end" ref={inputAdornmentRef}>
      <CircularProgress
        size={20}
        thickness={4}
        disableShrink
      />
    </InputAdornment>
  );
}

export default InputAdormentLoading;
